import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({ standalone: false,
  selector: 'edit-multiple-securities-dialog',
  templateUrl: './edit-multiple-securities-dialog.component.html',
  styleUrls: ['./edit-multiple-securities-dialog.component.scss']
})
export class EditMultipleSecuritiesDialogComponent implements OnInit {
  securities: Array<any>;
  editMultipleSecuritiesContinueFunction: Function;
  constructor(public dialogRef: MatDialogRef<EditMultipleSecuritiesDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public mdd: any) { }


  ngOnInit(): void {
    this.securities = this.mdd.securities as Array<any>;
    this.editMultipleSecuritiesContinueFunction = this.mdd.editMultipleSecuritiesContinueFunction || null;
  }

  close() {
    this.dialogRef.close();
  }

  editSelectedSecurities() {
    this.editMultipleSecuritiesContinueFunction();
    this.close();
  }
}
